import { render, staticRenderFns } from "./component.vue?vue&type=template&id=63f33262&scoped=true&"
import script from "./component.vue?vue&type=script&lang=js&"
export * from "./component.vue?vue&type=script&lang=js&"
import style0 from "./component.vue?vue&type=style&index=0&id=63f33262&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63f33262",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63f33262')) {
      api.createRecord('63f33262', component.options)
    } else {
      api.reload('63f33262', component.options)
    }
    module.hot.accept("./component.vue?vue&type=template&id=63f33262&scoped=true&", function () {
      api.rerender('63f33262', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-icon-select/component.vue"
export default component.exports